// Ensure jQuery is loaded before this script, as it uses $ (jQuery)

/**
 * Handles loading more items on collection pages.
 * This function is called when the 'Load More' button is clicked.
 *
 * @param {HTMLElement} button - The 'Load More' button element.
 */
const loadItems = (button) => {
    // Select the hidden input elements that store pagination data
    const totalPagesElement = $('[data-total-pages]');
    const currentPageElement = $('[data-current-page]');
    const nextUrlElement = $('[data-next-url]');

    // Validate if necessary hidden inputs exist
    if (!totalPagesElement.length || !currentPageElement.length || !nextUrlElement.length) {
        console.error('load-more.js: ERROR: Missing required hidden input elements for pagination. ' +
                      'Please ensure elements with data-total-pages, data-current-page, and data-next-url exist on the page.');
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        button.textContent = 'Error: Missing data.';
        return;
    }

    const totalPages = parseInt(totalPagesElement.val());
    let currentPage = parseInt(currentPageElement.val());
    let initialNextUrlValue = nextUrlElement.val(); // Capture initial value for debugging

    console.log(`--- CLICK #${currentPage} ---`);
    console.log(`LOG 1: Before increment - Current Page: ${currentPage}, Total Pages: ${totalPages}, Hidden next-url value: "${initialNextUrlValue}"`);

    // The URL for the AJAX request should come directly from the hidden input.
    // We will update this input *after* a successful fetch with the new cursor.
    const nextRequestUrl = nextUrlElement.val(); // *** CRITICAL CHANGE: Use the current value from the hidden input directly ***

    // We still increment currentPage for logging and for the 'totalPages' check later
    currentPage = currentPage + 1;

    console.log(`LOG 2: URL for AJAX request: "${nextRequestUrl}"`);
    // LOG 3: Hidden inputs are updated *after* success callback to reflect the new state from Shopify
    // So, this log is about the state *before* this click's AJAX result.
    console.log(`LOG 3: Hidden Inputs PRE-AJAX Update - [data-current-page].val(): ${currentPageElement.val()}, [data-next-url].val(): "${nextUrlElement.val()}"`);


    // Disable button and show loading state
    button.setAttribute("disabled", "");
    button.classList.add('loading');
    button.textContent = 'Loading...';

    // AJAX Request to Fetch More Products
    $.ajax({
        url: nextRequestUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML) {
            console.log('LOG 4: AJAX Success - Content received. Appending products.');

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = responseHTML;

            // Find the new product grid content to append
            const newProductsContainer = $(tempDiv).find('.load-more-grid');
            if (newProductsContainer.length) {
                $('.load-more-grid').append(newProductsContainer.html());
            } else {
                console.warn('load-more.js: WARNING: Could not find new products container in AJAX response (selector: .load-more-grid).');
            }

            // *** CRITICAL FIX: Find and update the hidden next-url from the received HTML ***
            const newNextUrlInput = $(tempDiv).find('[data-next-url]');

            if (newNextUrlInput.length) {
                // Update the hidden input on the *original page* with the new URL from the AJAX response
                nextUrlElement.val(newNextUrlInput.val());
                
                // Also update currentPageElement by extracting page number from the new URL (e.g., page=3)
                const newPageMatch = newNextUrlInput.val().match(/page=(\d+)/);
                if (newPageMatch && newPageMatch[1]) {
                    currentPageElement.val(parseInt(newPageMatch[1]) - 1); // If next URL is page=4, current is 3
                } else {
                    // Fallback if page parameter not found, assume it advanced one
                    currentPageElement.val(currentPage - 1); 
                }
                
                console.log(`LOG 4.1: Updated hidden [data-next-url] to: "${nextUrlElement.val()}"`);
                console.log(`LOG 4.2: Updated hidden [data-current-page] to: ${currentPageElement.val()}`);
            } else {
                console.warn('load-more.js: WARNING: Could not find new [data-next-url] input in AJAX response. Assuming last page.');
                // If there's no new next URL, it means we're likely on the last page.
                // Force current page to total pages to ensure button is removed.
                currentPage = totalPages; // Force to last page
                currentPageElement.val(totalPages); // Set the hidden input to the last page number
            }

            if (typeof colorSwatches === 'function') {
                colorSwatches();
            }
        },
        error: function(xhr, status, error) {
            console.error('load-more.js: ERROR: AJAX Request failed - Status:', status, 'Error:', error, 'XHR:', xhr);
            button.textContent = 'Error loading. Please try again.';
            button.removeAttribute("disabled");
            button.classList.remove('loading');
        },
        complete: function() {
            // This runs whether the AJAX call succeeded or failed
            // Use the *actual current page from the updated hidden input* for the final check
            const currentPgFromHidden = parseInt(currentPageElement.val());
            console.log(`LOG 5: AJAX Complete Handler - Current Page (from hidden input): ${currentPgFromHidden}, Total Pages: ${totalPages}`);

            button.removeAttribute("disabled");
            button.classList.remove('loading');

            if (currentPgFromHidden < totalPages) { // Compare actual current page from hidden input
                button.textContent = 'Load More';
                if (typeof checkVisibility === 'function') {
                    checkVisibility();
                }
            } else {
                console.log('LOG 6: All products loaded. Removing Load More button.');
                button.remove();
            }
        }
    });
};

// Ensure this listener is present and correct. It should be outside the loadItems function definition.
document.addEventListener("DOMContentLoaded", function() {
    console.log('load-more.js: DOMContentLoaded - Initializing Load More button listener.');
    const loadMoreButton = document.querySelector('.js-load-more');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(event) {
            event.preventDefault();
            loadItems(this);
        });
        console.log('load-more.js: Load More button listener attached.');

        // Initial check if the button should be visible (e.g., if total pages is 1, hide it)
        const totalPages = parseInt($('[data-total-pages]').val());
        const currentPage = parseInt($('[data-current-page]').val());
        if (currentPage >= totalPages) {
            loadMoreButton.remove();
            console.log('load-more.js: Button removed on initial load as all pages are already displayed.');
        }
    } else {
        console.warn('load-more.js: WARNING: No button with class ".js-load-more" found on page.');
    }
});